import './App.css';
import { Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import HomeDash from "./components/Dashboard/HomeDash";
import AdminLogin from "./components/AdminLogin";
import ViewApplication from "./components/Dashboard/ViewApplication";
import HomePage from './components/HomePage/HomePage'
import JobPage from './components/JobPages/JobPage';
import ApplyPage from './components/JobPages/ApplyPage';
import AllJobsPage from './components/JobPages/AllJobsPage';
import TrackApplication from './components/JobPages/TrackApplication';
import HirewithHH from './components/AboutPages/HirewithHH';
import TalentCommunity from './components/AboutPages/TalentCommunity';
import JoinTeam from './components/AboutPages/JoinTeam';
import Blogs from './components/Blogs/Blogs';
import BlogPage from './components/Blogs/BlogPage';

function App() {

  return (

    <Routes>
      {/* Main  Layout */} 
      <Route path="/" element={<Layout />}>
        {/* Public Routes */}
        <Route index element={<HomePage />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/dashboard" element={<HomeDash />} />
        <Route path="/viewapplication/:id" element={<ViewApplication />} />


        <Route path="/job/:id" element={<JobPage />} />
        <Route path="/apply/:id" element={<ApplyPage />} />
        <Route path="/TrackApplication" element={<TrackApplication />} />
        <Route path="/jobs" element={<AllJobsPage />} />

        <Route path="/hirewithHH" element={<HirewithHH />} />
        <Route path="/talentcommunity" element={<TalentCommunity />} />
        <Route path="/jointeam" element={<JoinTeam />} />

        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<BlogPage />} />


        {/* Protected Routes */}
        {/* <Route element={<RequireAuth />}>
          <Route path="/admin/homepage" element={<AdminHomePage />} />
            
        </Route> */}




      </Route>
    </Routes>
  );
}

export default App;
